import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LTClientInfoModule } from './lt-client-info/lt-client-info.module';
import { LTConfigurationInfoModule } from './lt-configuration-info/lt-configuration-info.module';
import { LTProcessDataModule } from './lt-process-data/lt-process-data.module';
import { LTEditConfigRoutingModule } from './lt-edit-config-routing.module';
@NgModule({
  imports: [
    CommonModule,
    LTEditConfigRoutingModule,
    LTClientInfoModule,
    LTConfigurationInfoModule,
    LTProcessDataModule,
  ],
  exports: [
    LTClientInfoModule,
    LTConfigurationInfoModule,
    LTProcessDataModule,
  ],
})
export class LTEditConfigModule { }